<template>
  <div class="box17">
    <div class="left-box">
      软件测试学习路线图
      <div class="left-btn" @click="zixun('免费领取')">免费领取</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    zixun(name) {
     this.mai("软件测试-就业课","免费领取",0,null)
      window.open("https://m.boxuegu.com/route/test");
      //this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box17 {
  position: relative;
  width: 100%;
  height: 270px;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/softwareTest/box17/bg.png")
    no-repeat;
  background-size: cover;
  .left-box {
    position: absolute;
    top: 110px;
    left: 64px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 40px;
    .left-btn {
      margin-top: 32px;
      width: 160px;
      height: 56px;
      background: #ffffff;
      border-radius: 8px;

      text-align: center;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2ea5fc;
      line-height: 56px;
    }
  }

  .box14-icon {
    position: absolute;
    right: 28px;
    bottom: -30px;
    width: 300px;
    height: 272px;
  }
}
</style>
